var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.381,
    height: 37.369,
    viewBox: "0 0 38.381 37.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 0.898,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#338fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43c6fe"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_1",
    x: 0,
    y: 1,
    width: 38.381,
    height: 36.369,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_111805",
    "data-name": "Group 111805",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111806",
    "data-name": "Group 111806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_21094",
    "data-name": "Rectangle 21094",
    fill: "none",
    stroke: "#39a4f4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, 0)",
    filter: "url(#Union_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1-2",
    "data-name": "Union 1",
    d: "M2.874,18.37A2.879,2.879,0,0,1,.008,16.109a.417.417,0,0,1,.4-.5H19.973a.417.417,0,0,1,.4.5,2.879,2.879,0,0,1-2.866,2.261Zm5.57-1.383a.335.335,0,0,0,.332.338H11.6a.338.338,0,0,0,0-.676H8.777A.335.335,0,0,0,8.444,16.987Zm-6.35-2.058V4.253a.857.857,0,0,1,.851-.862h.813v9.845H16.624V7.9c.362-.01.727-.033,1.089-.071a1.5,1.5,0,0,0,.575-.175v7.277Zm4.181-3.711a.372.372,0,0,1-.369-.375v-2.1a1.18,1.18,0,0,1-.791-1.119V6.414A2.39,2.39,0,0,1,5.8,4.725a2.338,2.338,0,0,1,1.659-.7A1.592,1.592,0,0,1,6.29,3.511a1.646,1.646,0,0,1-.437-1.122,1.609,1.609,0,1,1,3.217,0A1.647,1.647,0,0,1,8.711,3.42a1.6,1.6,0,0,1-1.25.606h.327a3.125,3.125,0,0,1,1.56.511l1.749.885.782-1.591a.366.366,0,0,1,.5-.168.379.379,0,0,1,.165.5l-.916,1.865a.99.99,0,0,1-.01.6v0a1.022,1.022,0,0,1-.573.62,1,1,0,0,1-.838-.033l-1.182-.6v4.223a.372.372,0,0,1-.369.375ZM14.7,6.79H12.337a1.751,1.751,0,0,0,.058-.647L13.2,4.5a1.137,1.137,0,0,0-.5-1.513,1.1,1.1,0,0,0-1.487.5l-.452.92-.9-.457V1.181A1.171,1.171,0,0,1,11.022,0h5.539a1.171,1.171,0,0,1,1.16,1.181V5.609a1.171,1.171,0,0,1-1.16,1.181ZM13.742,4.8a.372.372,0,0,0,.369.375h1.657a.376.376,0,0,0,0-.752H14.112A.373.373,0,0,0,13.742,4.8Zm0-1.409a.373.373,0,0,0,.369.376h1.657a.376.376,0,0,0,0-.752H14.112A.373.373,0,0,0,13.742,3.395Zm-2.3-1.409a.372.372,0,0,0,.369.376h3.955a.376.376,0,0,0,0-.752H11.813A.372.372,0,0,0,11.444,1.986Z",
    transform: "translate(9 7)",
    fill: "url(#linear-gradient)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.3086be5b746df42dd9d90fa09644732f.svg";
export { ForwardRef as ReactComponent };